import { memo } from "react";
import ErrorPage from '../pages/ErrorPage';

export const FallbackRender = memo(({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) => (
  <ErrorPage error={error} onRetry={resetErrorBoundary} />
));